<template>
    <v-container id="ra-building-preference" fluid>
        <v-row>
            <v-col cols="12" lg="6">
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-home-floor-1</v-icon>Building - First Choice
                </v-card-subtitle>
                <v-select v-model="item.buildingOption01" dense :items="getBuildingsOptionOne"
                    label="Building Preference" outlined :rules="buildingOption01Rules" required>
                </v-select>
                <v-text-field v-model="item.buildingUnit01" dense label="Please indicate which unit(s) you would prefer"
                    outlined>
                </v-text-field>
                <v-text-field v-model="item.buildingPartner01" dense hide-details
                    label="Please indicate any preferred Residence Assistant partner" outlined>
                </v-text-field>
                <v-checkbox v-model="item.buildingContractCondition01" false-value="0"
                    :rules="buildingContractConditionRules" label="I have read and agree to the contract conditions"
                    true-value="1" required></v-checkbox>
            </v-col>
            <v-col cols="12" lg="6">
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-home-floor-2</v-icon>Building - Second Choice
                </v-card-subtitle>
                <v-select v-model="item.buildingOption02" dense :items="getBuildingsOptionTwo"
                    label="Building Preference" outlined :rules="buildingOption02Rules" required>
                </v-select>
                <v-text-field v-model="item.buildingUnit02" dense label="Please indicate which unit(s) you would prefer"
                    outlined>
                </v-text-field>
                <v-text-field v-model="item.buildingPartner02" dense hide-details
                    label="Please indicate any preferred Residence Assistant partner" outlined>
                </v-text-field>
                <v-checkbox v-model="item.buildingContractCondition02" false-value="0"
                    :rules="buildingContractConditionRules" label="I have read and agree to the contract conditions"
                    true-value="1" required></v-checkbox>
            </v-col>
            <v-col cols="12" lg="6">
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-home-floor-3</v-icon>Building - Third Choice
                </v-card-subtitle>
                <v-select v-model="item.buildingOption03" dense :items="getBuildingsOptionThree"
                    label="Building Preference" outlined>
                </v-select>
                <v-text-field v-model="item.buildingUnit03" dense label="Please indicate which unit(s) you would prefer"
                    outlined>
                </v-text-field>
                <v-text-field v-model="item.buildingPartner03" dense hide-details
                    label="Please indicate any preferred Residence Assistant partner" outlined>
                </v-text-field>
                <v-checkbox v-model="item.buildingContractCondition03" false-value="0"
                    :rules="buildingContractConditionRules" label="I have read and agree to the contract conditions"
                    true-value="1"></v-checkbox>
            </v-col>
            <v-col cols="12">
                <v-select v-model="item.buildingUnitPreference" dense :items="buildingUnitPreferenceItems"
                    label="Unit Preference" outlined placeholder="Please select..." :rules="buildingUnitPreferenceRules"
                    required>
                </v-select>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-basket</v-icon>Meal Plan Information
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-select v-model="item.residenceMealPlan" dense
                    hint="Note: These costs are approximate. Final costs are subject to Board approval."
                    :items="getResidenceMealPlanItems" label="Meal Plan" outlined persistent-hint
                    placeholder="Please select..." :rules="residenceMealPlanRules" required>
                </v-select>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'applicant-ra-building-preference',
    props: {
        formSettings: {
            required: true
        },
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            buildingContractConditionRules: [
                v => !!v || ''
            ],
            buildingOption01Rules: [
                v => !!v || 'First choice building preference is required'
            ],
            buildingOption02Rules: [
                v => !!v || 'Second choice building preference is required'
            ],
            buildingOption03Rules: [
                v => !!v || 'Third choice building preference is required'
            ],
            buildingUnitPreferenceItems: [{
                    text: 'Single Gender Unit',
                    value: 'Single Gender Unit'
                },
                {
                    text: 'Mixed Gender Unit',
                    value: 'Mixed Gender Unit'
                },
            ],
            buildingUnitPreferenceRules: [
                v => !!v || 'Unit preference is required'
            ],
            genders: {
                F: 'Female',
                M: 'Male',
                Other: 'Other'
            },
            residenceMealPlanRules: [
                v => !!v || 'Residence meal plan is required'
            ]
        }
    },
    computed: {
        getBuildingsOptionOne() {
            let buildings = this.formSettings.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.item.gender] || '';
            let reg = new RegExp(`^${gender}`, 'i');

            for (let i = 0; i < buildings.length; i++) {
                let genderBool = false;

                // Gender restriction check
                if (gender && buildings[i].genderRestriction.length > 0) {
                    let restrictions = buildings[i].genderRestriction;

                    for (let j = 0; j < restrictions.length; j++) {
                        if (restrictions[j].match(reg)) {
                            genderBool = true;
                            break;
                        }
                    }
                } else if (gender) {
                    genderBool = true;
                }

                if (genderBool) {
                    currentBuildings.push({
                        text: buildings[i].name,
                        value: buildings[i].name
                    });
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingsOptionTwo() {
            let buildings = this.formSettings.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.item.gender] || '';
            let reg = new RegExp(`^${gender}`, 'i');
            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name != this.item.buildingOption01) {
                    let genderBool = false;

                    // Gender restriction check
                    if (gender && buildings[i].genderRestriction.length > 0) {
                        let restrictions = buildings[i].genderRestriction;

                        for (let j = 0; j < restrictions.length; j++) {
                            if (restrictions[j].match(reg)) {
                                genderBool = true;
                                break;
                            }
                        }
                    } else if (gender) {
                        genderBool = true;
                    }

                    if (genderBool) {
                        currentBuildings.push({
                            text: buildings[i].name,
                            value: buildings[i].name
                        });
                    }
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingsOptionThree() {
            let buildings = this.formSettings.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.item.gender] || '';
            let reg = new RegExp(`^${gender}`, 'i');
            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name != this.item.buildingOption01 && buildings[i].name != this.item.buildingOption02) {
                    let genderBool = false;

                    // Gender restriction check
                    if (gender && buildings[i].genderRestriction.length > 0) {
                        let restrictions = buildings[i].genderRestriction;

                        for (let j = 0; j < restrictions.length; j++) {
                            if (restrictions[j].match(reg)) {
                                genderBool = true;
                                break;
                            }
                        }
                    } else if (gender) {
                        genderBool = true;
                    }

                    if (genderBool) {
                        currentBuildings.push({
                            text: buildings[i].name,
                            value: buildings[i].name
                        });
                    }
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getResidenceMealPlanItems() {
            let buildings = this.formSettings.buildings || [];
            let mealPlanItems = [...this.formSettings.mealPlans];
            let required = false;

            // Slice
            mealPlanItems.length = 3;

            if (this.item.buildingOption01 || this.item.buildingOption02) {
                for (let i = 0; i < buildings.length; i++) {
                    if ((buildings[i].name == this.item.buildingOption01 || buildings[i].name == this.item.buildingOption02) && buildings[i].mealPlanRequired == "1") {
                        required = true;
                        break;
                    }
                }
            }

            // Required meal plan
            if (required) {
                return mealPlanItems;
            }

            return this.formSettings.mealPlans;
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>

<style scoped>
.col-12 {
    padding-bottom: 0;
    padding-top: 0;
}
</style>